<template>
  <div>
    <v-dialog max-width="800px" hide-overlay v-model="openDialog" persistent>
      <v-card>
        <v-card-title
          style="background-color: rgb(21, 101, 192); color: white;"
        >
          ข้อมูลงานซ่อม
        </v-card-title>
        <v-container>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">สถานะ</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{ jobDetail.jobStatusName }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">เลขตัวถัง</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{ jobDetail.car.bodyNumber }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">ใบสั่งซ่อม</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{ jobDetail.jobNo }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">ทะเบียน</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{ jobDetail.car.licenseNo }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">รุ่น</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{ jobDetail.car.modelName }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">สี</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{ jobDetail.car.colorName }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">จน.ชิ้นงาน</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{ jobDetail.sumTransCount }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">ค่าแรง</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{ jobDetail.sumServiceTotal }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">ประเภทงาน</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{ jobDetail.jobSize }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">วันที่เข้าซ่อม</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{ jobDetail.jobDate }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">วันที่ นัดเสร็จ</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{ jobDetail.appointDate }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">ช่าง</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2 ">
                  {{
                    jobDetail.jobServiceDetail.length > 0
                      ? listJobDetail(jobDetail.jobServiceDetail, 'name')
                      : null
                  }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">วันที่ เปิดงาน</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2">
                  {{
                    jobDetail.jobServiceDetail.length > 0
                      ? listJobDetail(jobDetail.jobServiceDetail, 'startDate')
                      : null
                  }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">เวลา เปิดงาน</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2 ">
                  {{
                    jobDetail.jobServiceDetail.length > 0
                      ? listJobDetail(jobDetail.jobServiceDetail, 'startTime')
                      : null
                  }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">SA</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2 ">
                  {{ jobDetail.empContact }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
           <v-row no-gutters>
            <v-layout row wrap>
              <v-flex xs4 md4 class="text-right">
                <div class="pa-2">หมายเหตุ</div>
              </v-flex>
              <v-flex xs4 md4 class="text-center">
                <div class="pa-2">:</div>
              </v-flex>
              <v-flex xs4 md4 class="text-left">
                <div class="pa-2 ">
                  {{ jobDetail.remark }}
                </div>
              </v-flex>
            </v-layout>
          </v-row>
          <v-card-actions>
            <v-btn color="primary" @click="linkJob">
              ดูข้อมูล
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="close">
              CLOSE
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'popup',
  data() {
    return {
      jobDetail: {
        jobStatusName: null,
        car: {
          bodyNumber: null,
          modelName: null,
          colorName: null,
        },
        jobNo: null,
        licenseNo: null,
        sumTransCount: null,
        sumServiceTotal: null,
        jobSize: null,
        jobDate: null,
        appointDate: null,
        jobServiceDetail: [],
        customer: {
          customerName: null,
        },
        remark: null
      },
    };
  },
  props: ['jobId', 'openDialog', 'branchCode'],
  methods: {
    linkJob() {
      this.$router.push({
        name: 'edit-job',
        params: {pageCode: 'J01', branchCode: this.branchCode, jobId: this.jobDetail.jobId },
      });
    },
    setJobDetail(data) {
      this.jobDetail = {
        jobId: data.jobId,
        jobStatusName: data.jobStatusName,
        car: {
          bodyNumber: data.car ? data.car.bodyNumber : null,
          modelName: data.car ? data.car.modelName : null,
          colorName: data.car ? data.car.colorName : null,
          licenseNo: data.car ? data.car.licenseNo : null,
        },
        jobNo: data.jobNo,
        sumTransCount: data.sumTransCount,
        sumServiceTotal: data.sumServiceTotal,
        jobSize: data.jobSize,
        jobDate: data.jobDate,
        appointDate: data.appointDate,
        jobServiceDetail: data.jobServiceDetail,
        customer: {
          customerName: data.customer ? data.customer.customerName : null,
        },
        empContact: data.empContact,
        remark: data.remark
      };
    },
    close() {
      this.$emit('closeDialog');
    },
    listJobDetail(value, key) {
      if (key == 'name') {
        return value[value.length - 1].empFullname;
      } else if (key == 'startDate') {
        return value[value.length - 1].startDate;
      } else if (key == 'startTime') {
        return value[value.length - 1].startTime;
      }
    },
  },
};
</script>
